import { bg } from './bg';

export * from './bg';

/**
 * Шевът за език. Речникът се ползва като обект (`t.board.title`), защото
 * TypeScript проверява всеки ключ при компилация — нещо, което низовите
 * ключове на i18n рамките не правят.
 */
export const t = bg;

/** Замества {име} в низ. Ползва се само там, където има променлива. */
export function fill(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = vars[key];
    return value === undefined ? match : String(value);
  });
}

/**
 * Българското множествено число за броячи: 1 бус / 2 буса.
 * Достатъчно за интерфейс, в който броячите са от рода „3 заявки".
 */
export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}
